// Here rather than in Extract, because the decision needs contexts Extract renders.

import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  DE2OutstandingSuggestion,
  useDE2OutstandingSuggestions,
} from './useDE2OutstandingSuggestions';
import { OutstandingSuggestionsModal } from 'concepts/AutoDocExtraction/OutstandingSuggestionsModal/OutstandingSuggestionsModal';
import { TemplateBlock } from 'concepts/Extraction/Blocks/BaseBlock';
import { Button } from 'components/core';

export type CompleteButtonProps = {
  blocks: TemplateBlock[];
  form: UseFormReturn;
  // Send for Consensus is a completing action too, and worth interrupting.
  singleExtractor: boolean;
  isCompleting: boolean;
  onComplete: () => void;
  onReviewSuggestions: (first: DE2OutstandingSuggestion) => void;
};

export const CompleteButton = ({
  blocks,
  form,
  singleExtractor,
  isCompleting,
  onComplete,
  onReviewSuggestions,
}: CompleteButtonProps): JSX.Element => {
  const { findOutstanding, rejectAll, tracking } = useDE2OutstandingSuggestions(
    {
      blocks,
      form,
    }
  );
  const [outstanding, setOutstanding] = useState<
    DE2OutstandingSuggestion[] | null
  >(null);

  const label = singleExtractor ? 'Complete' : 'Send for Consensus';
  const busyLabel = singleExtractor ? 'Completing…' : 'Sending for Consensus…';

  const requestComplete = () => {
    const undecided = findOutstanding();

    if (undecided.length === 0) {
      onComplete();
      return;
    }

    tracking.modalViewed(undecided);
    setOutstanding(undecided);
  };

  return (
    <>
      <Button type="brand" disabled={isCompleting} onClick={requestComplete}>
        {isCompleting ? busyLabel : label}
      </Button>
      {outstanding && (
        <OutstandingSuggestionsModal
          outstanding={outstanding}
          onDismiss={() => {
            tracking.modalDismissed(outstanding);
            setOutstanding(null);
          }}
          onRejectAllAndComplete={() => {
            tracking.modalRejectAll(outstanding);
            rejectAll(outstanding);
            setOutstanding(null);
            onComplete();
          }}
          onReviewSuggestions={() => {
            tracking.modalReview(outstanding);
            setOutstanding(null);
            onReviewSuggestions(outstanding[0]);
          }}
        />
      )}
    </>
  );
};
